module.exports = __webpack_public_path__ + "static/img/qnstatus5.a6ef506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnstatus5.png
// module id = 367
// module chunks = 0